export enum Platform {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  LINE = 'line',
}

export interface IChannel {
  id: string;
  name: string;
  platform: string;
  agentSettings: IAgentSettings;
  createdAt: Date;
  updatedAt: Date;
}

export type AgentType = 'chat' | 'comment';

export type IAgentSettings = Record<AgentType, IAgentConfig>;

export interface IAgentConfig {
  isActive: boolean;
  isNotify: boolean;
  isAlwaysOn: boolean;
  weekday?: IAgentSchedule;
  weekend?: IAgentSchedule;
}

export interface IAgentSchedule {
  start: string;
  end: string;
}
